/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbRespInteriorsWordpressArticlesWrapper_itemSearch = {
    readonly editorial: {
        readonly " $fragmentRefs": FragmentRefs<"SbRespInteriorsModule_editorial" | "SbSharedWordpressArticlesWrapper_editorial">;
    } | null;
    readonly interiorPhotos: {
        readonly photos: ReadonlyArray<{
            readonly serviceId: string | null;
        } | null> | null;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"SbRespInteriorsModule_itemSearch">;
    readonly " $refType": "SbRespInteriorsWordpressArticlesWrapper_itemSearch";
};
export type SbRespInteriorsWordpressArticlesWrapper_itemSearch$data = SbRespInteriorsWordpressArticlesWrapper_itemSearch;
export type SbRespInteriorsWordpressArticlesWrapper_itemSearch$key = {
    readonly " $data"?: SbRespInteriorsWordpressArticlesWrapper_itemSearch$data;
    readonly " $fragmentRefs": FragmentRefs<"SbRespInteriorsWordpressArticlesWrapper_itemSearch">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespInteriorsWordpressArticlesWrapper_itemSearch",
  "selections": [
    {
      "alias": "editorial",
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 3
        }
      ],
      "concreteType": "WordpressArticlesType",
      "kind": "LinkedField",
      "name": "editorialArticles",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SbRespInteriorsModule_editorial"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SbSharedWordpressArticlesWrapper_editorial"
        }
      ],
      "storageKey": "editorialArticles(first:3)"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SearchBrowseInteriorPhotosModule",
      "kind": "LinkedField",
      "name": "interiorPhotos",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PhotosSearchBrowsePhoto",
          "kind": "LinkedField",
          "name": "photos",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "serviceId",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespInteriorsModule_itemSearch"
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};
(node as any).hash = 'e14269e42aeb0139f141432af8f66d7f';
export default node;
